<template>
  <v-dialog v-model="active" width="800" persistent>
    <v-card>
      <v-card-title primary-title>
        <img :src="require('@/assets/shield.svg')" style="margin-right:1em;" contain height="50" alt="Covenant Shield Logo" />
        Scots Connect Offline
      </v-card-title>
      <v-card-text>
        <p>You are currently unable to connect to Scots Connect. This could be due to planned maintenance, or a problem with the server, or a problem with your device or network.</p>
        <ul>
          <li>Refresh the page. If it's planned maintenance then a maintenance message should appear. If not, then it may be a connection problem on your end.</li>
          <li>Scots Connect uses a websocket to connect to the server. Some public networks block access to websockets, so if you are on a public network then you may need to try a different network.</li>
          <li>Some Internet Security software blocks access to the websocket. In this case you may need to either turn off your internet security software while using Scots Connect, or find a way to add an exception for portal.covenant.edu:3030.</li>
        </ul>
        <p style="margin-top:1em">If none of the above helps and the system remains offline, please contact Tech Support at <a href="mailto:techsupport@covenant.edu?subject=Scots+Portal+Offline" target="_blank">techsupport@covenant.edu</a> to report this problem.</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed } from '@vue/composition-api'
export default {
  setup (props, { root }) {
    const active = computed(() => root.$store.state.offline)

    return {
      active
    }
  }
}
</script>
